import actionTypes from 'SRC/modules/redux/actionTypes'

export const setRegistrationFormulaDetails = formula => {
  return {
    type: actionTypes.SET_REGISTRATION_FORMULA_DETAILS,
    payload: formula
  }
}
